/**
 * JS based off IS+ support team's code snippet
 */

var __isp_options = __isp_options || {};

var isp_related_options = isp_related_options || {};

isp_related_options.with_product_attributes = true;

var runOnlyOnInit = false

__isp_options.isp_serp_callback = function (data, facetsOnly) {
  if (window.quickViewCB) window.quickViewCB(data, facetsOnly)

  if (!runOnlyOnInit) {
    $('#search_res_sorting_title').text('Sort by')

    if (window.innerWidth >= 1024) {
      $('#isp_search_result_page_container').prepend($('.isp_center_container_header'))
    } else {
      $('#isp_left_container').prepend($('.isp_center_container_header') )
    }

    window.addEventListener('resize', (evt) => {
      if (window.innerWidth >= 1024) {
        $('#isp_search_result_page_container').prepend($('.isp_center_container_header'))
      } else {
        $('#isp_left_container').prepend($('.isp_center_container_header') )
      }
    })

    $('.smart-collection__mobile-filter-button').click((evt) => {
      $('.smart-collection__mobile-filter-button').toggleClass('opened')
      $('.isp_left_container').toggleClass('opened')
      $('.isp_center_container').toggleClass('closed')
    })

    $('.smart-collection__pagination__button__prev').click((evt) => {
      evt.preventDefault()
      $('.isp_pagination .prev').click()
    })

    $('.smart-collection__pagination__button__next').click((evt) => {
      evt.preventDefault()
      $('.isp_pagination .next').click()
    })

    runOnlyOnInit = true
  }

  if (!facetsOnly) {
    $('.smart-collection__pagination__current').text(data.p)
    $('.smart-collection__pagination__max').text(data.total_p)

    if (data.p === 1) {
      $('.smart-collection__pagination__button__prev').hide()
      $('.smart-collection__pagination__button__next').show()
    } else if (data.p === data.total_p) {
      $('.smart-collection__pagination__button__prev').show()
      $('.smart-collection__pagination__button__next').hide()
    } else {
      $('.smart-collection__pagination__button__prev').show()
      $('.smart-collection__pagination__button__next').show()
    }
  }

  const maxPages = document.querySelector('.smart-collection__pagination__max')
  const maxPagesNumber = Number(maxPages.textContent)
  if (maxPagesNumber <= 1) {
    $('.smart-collection__pagination').hide()
    $('.isp_center_container').css('padding-bottom', '80px')
  }
  
  const imageTitleEls = [...document.querySelectorAll('.isp_product_info .isp_product_image_href')]
  imageTitleEls.forEach((imageTitleEl, i) => {
    imageTitleEl.insertAdjacentHTML('afterend', `
      <a class="isp_product_reviews" href="${data.items[i].u}#reviews">
        <div class="yotpo-widget-instance"
          data-yotpo-instance-id="${ window.akc.yotpo.starsWidgetInstanceID }"
          data-yotpo-product-id="${data.items[i].id}"
          data-yotpo-cart-product-id="${data.items[i].id}"
          data-yotpo-section-id="template-collection">
        </div>
      </a>
    `)
  })

  if (typeof yotpoWidgetsContainer !== 'undefined') {
    yotpoWidgetsContainer.initWidgets()
  }

  // if ($('.filter-input').length < 1) {
  //   $jquery_isp('.isp_facet_title').each(function () {
  //     let checkParent = $(this).parent().attr('class').match(/[\d\w-_]+/g)[1];
  //     let parentData = document.querySelector('.' + checkParent);

  //     if ($(parentData).children('.isp_facet_value').length > 2)
  //       $(this).after('<input type="text" isp_ignore class="filter-input" placeholder="Refine Search">')
  //   });
  // }

  // $(document).on('click', '.filter-input', function () {
  //   // locate parent div of clicked
  //   let clickedInput = $(this).parent().attr('class').match(/[\d\w-_]+/g)[1]
  //   let searchInput = document.querySelector(`.${clickedInput} .filter-input`);

  //   // get all title
  //   let titles = document.querySelectorAll(`.isp_single_facet_wrapper.${clickedInput} .isp_facet_value`);
  //   let searchTerm = '';
  //   let tit = '';

  //   // get input field and add 'keyup' event listener
  //   searchInput.addEventListener('keyup', (e) => {
  //     e.stopImmediatePropagation(); //run function once
  //     let showHide = $(`.${clickedInput} .isp_facet_show_hide_values`)

  //     if ($(`.isp_single_facet_wrapper .${clickedInput} .isp_facet_unvisible_values`).css('display') === 'none') {
  //       showHide.trigger('click');
  //     }

  //     // get input fieled value and change it to lower case
  //     searchTerm = e.target.value.toLowerCase();

  //     titles.forEach((title) => {
  //       // navigate to p in the title, get its value and change it to lower case
  //       tit = title.textContent.toLowerCase();

  //       // it search term not in the title's title hide the title. otherwise, show it.
  //       tit.includes(searchTerm) ? title.style.display = 'block' : title.style.display = 'none';
  //     });

  //     // if we have 3 or less remaining items from the filter, hide the show more button
  //     $(`.${clickedInput} .isp_facet_value[style="display: block;"]`).length <= 3 ? showHide.hide() : showHide.show()
  //   });
  // });
};
